import { Box, Typography, Chip } from '@mui/material'
import { styled, keyframes } from '@mui/material/styles'
import { COLORS } from '../../constants/colors'

const slideIn = keyframes`
  from { opacity: 0; transform: translateY(-8px); }
  to   { opacity: 1; transform: translateY(0); }
`

const AlertBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '12px 16px',
  borderRadius: 12,
  border: `1px solid ${COLORS.blue.border}`,
  background: COLORS.blue.muted,
  animation: `${slideIn} .3s ease-out`,
}))

const Mono = styled(Typography)(() => ({
  fontFamily: "'JetBrains Mono', monospace",
  fontSize: '0.75rem',
}))

/**
 * Whale alert card — shown for Pro+ tiers.
 * @param {{ wallet, symbol, amount, action, timestamp }} props
 */
export default function WhaleAlert({ wallet, symbol, amount, action = 'buy', timestamp }) {
  const isBuy = action === 'buy'

  return (
    <AlertBox>
      <Box sx={{ fontSize: 22, lineHeight: 1 }}>🐋</Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.3 }}>
          <Typography sx={{ fontWeight: 700, fontSize: '0.85rem' }}>
            Whale {isBuy ? 'Buy' : 'Sell'}
          </Typography>
          <Chip
            label={symbol || '???'}
            size="small"
            sx={{
              height: 20,
              fontSize: '0.65rem',
              fontWeight: 700,
              color: isBuy ? COLORS.green.primary : COLORS.red.primary,
              background: isBuy ? COLORS.green.muted : COLORS.red.muted,
            }}
          />
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          {amount != null && (
            <Mono sx={{ color: COLORS.text.secondary }}>
              {isBuy ? '+' : '-'}{Number(amount).toLocaleString()} SOL
            </Mono>
          )}
          {wallet && (
            <Mono sx={{ color: COLORS.text.muted }}>
              {wallet.slice(0, 4)}…{wallet.slice(-4)}
            </Mono>
          )}
        </Box>
      </Box>

      <Mono sx={{ color: COLORS.text.muted, fontSize: '0.65rem', flexShrink: 0 }}>
        {timestamp ? new Date(timestamp).toLocaleTimeString() : ''}
      </Mono>
    </AlertBox>
  )
}
